<template>
    <div class="page">
        <!-- Banner -->
        <motor-banner v-if="main" :bgimg="{
            src: env.imageUrl + main.banner.banner_showroom.image,
            loading: env.imageUrl + main.banner.banner_showroom.thumb_image,
        }" :title="main.banner.banner_showroom.title" :sub_title="main.banner.banner_showroom.subtitle" />
        <div class="motor-container">
            <aside class="aside">
                <nav class="buttons">
                    <button class="button--nav"
                        v-for="(brand, index) in brands" :key="brand.id"
                        @click="activeShowroom = index"
                        :class="{'active': (activeShowroom === index)}">
                        {{brand.name}} | {{index}}
                    </button>
                </nav>
                <div class="showrooms showroom--sm" v-if="brands.length" :key="activeShowroom">
                    <ul>
                        <li v-for="showroom in brands[activeShowroom].category" :key="showroom.id">
                            <router-link :to="'/wedo/showroom/' + showroom.id">{{showroom.name}}</router-link>
                        </li>
                    </ul>
                </div>
                <div class="showrooms showroom--lg">
                    <div v-for="brand in brands" :key="brand.id">
                        <h2>{{brand.name}}</h2>
                        <ul>
                            <li v-for="showroom in brand.category" :key="showroom.id">
                                <router-link :to="'/wedo/showroom/' + showroom.id">{{showroom.name}}</router-link>
                            </li>
                        </ul>
                    </div>
                </div>
            </aside>
            <router-view/>
        </div>
        <!-- Footer -->
        <motor-footer :data="main" />
    </div>
</template>

<script>
import {mapState, mapActions, mapGetters} from 'vuex'
import MotorBanner from '@/components/MotorBanner.vue'
import BannerImg from '@/assets/images/home-banner.jpg'
import { env } from '../enviorments'

export default {
    name: 'showroom',
    components: {
        MotorBanner,
    },
    watch: {
        '$route'(to, from) {
            window.scrollTo(0, 300)
            const id = to.params.id
            if (id == 0) this.$router.replace('/wedo/showroom/' + this.brands[0].category[0].id)
        }
    },
    computed: {
        ...mapState({
            main: state => state.main,
            brands: state => state.brands
        }),
    },
    data() {
        return {
            BannerImg,
            activeShowroom: 0,
            env,
        }
    },
    methods: {
        ...mapActions({
            callBreands: 'callBreands',
            callMain: 'callMain',
        }),
    },
    async mounted() {
        if (!this.main) await this.callMain()
        await this.callBreands()
        const id = this.$route.params.id
        if (id == 0) this.$router.replace('/wedo/showroom/' + this.brands[0].category[0].id)
    }
}
</script>

<style lang="scss" scoped>
.page {
    .motor-container {
        @media (max-width: 991.9px) {
            max-width: 600px;
        }
        @media (min-width: 992px) {
            display: flex;
            padding: 60px 10px;
        }
        .aside {
            padding: 20px 0 0;
            @media (min-width: 992px) {
                width: 40%;
                min-width: 25%;
            }
            .buttons {
                width: 100%;
                display: flex;
                @media (min-width: 992px) {
                    display: none;
                }
                .button--nav {
                    flex: 1;
                    padding: 10px 0;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    text-transform: uppercase;
                    &.active {
                        background-color: #f0f0f0;
                        border-radius: 8px 8px 0 0;
                    }
                }
            }
        }
        .showrooms {
            @media (min-width: 992px) {
                width: 60%;
                flex: 1;
            }
            ul {
                margin: 0;
                padding: 0;
                list-style: none;
                li {
                    a {
                        display: block;
                        padding: 10px;
                        text-decoration: none;
                        text-transform: uppercase;
                        color: #333;
                        &.router-link-exact-active {
                            color: var(--primary);
                        }
                    }
                }
            }
            &.showroom--sm {
                display: block;
                background-color: #f0f0f0;
                padding: 10px;
                @media (min-width: 992px) {
                    display: none;
                }
            }
            &.showroom--lg {
                width: calc(100% - 20px);
                display: none;
                @media (min-width: 992px) {
                    display: block;
                }
                h2 {
                    font-size: 2rem;
                    color: var(--primary);
                    padding: 0;
                }
                ul {
                    margin: 10px 0 40px;
                    li {
                        a {
                            padding: 15px 10px;
                            border-bottom: 1px solid #eee;
                        }
                    }
                }
            }
        }
    }
}
</style>

